import { Typography } from "@material-ui/core"
import { useIsDesktop } from "common/MediaQueries"
import { mapDataToFitCarousel } from "common/mapDataToFitCarousel"
import useRedirectIfPreviousComponentsAreNotSelected from "common/useRedirectIfPreviousComponentsAreNotSelected"
import ColorsCarousel from "components/carModelPage/sections/exterior/enterence/ColorsCarousel"
import { memo, useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { useAppDispatch, useTypedSelector } from "store"
import styled from "styled-components"
import Colors from "./Colors"
import ThreeSixtyIcon from "./ThreeSixtyIcon"
import { setSelectedColor } from "./colorSlice"

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
`

const StyledIconWrapper = styled.div`
  display: flex;
  justify-content: center;

  position: relative;
  top: -50px;
`

const ColorSidebar = () => {
  useRedirectIfPreviousComponentsAreNotSelected()
  const isDesktop = useIsDesktop()
  const [selectedColorIndex, setSelectedColorIndex] = useState(0)
  const dispatch = useAppDispatch()
  const { pathname } = useLocation()
  const { showOnlyStock } = useTypedSelector((state) => state.wizard)

  const { colors, selectedColorCode } = useTypedSelector((state) => state.color)
  const colorsData = mapDataToFitCarousel(colors, "colorImage")

  const filteredColors = colorsData.filter((item) =>
    showOnlyStock ? item.inStock : true
  )
  // Find the index of selectedColor in the colors array

  useEffect(() => {
    setSelectedColorIndex(
      colors.reduce((a, b, i) => {
        if (b?.details?.code === selectedColorCode) return i
        return a
      }, 0)
    )
  }, [selectedColorCode, colors])

  return (
    <>
      <StyledWrapper>
        <Typography variant="srOnly" component={"h1"}>
          צבע
        </Typography>
        {isDesktop ? (
          <Colors
            type="colors"
            data={filteredColors}
            selectedItem={selectedColorCode}
            handleColorChange={(code) => {
              dispatch(setSelectedColor(code))
            }}
          />
        ) : (
          <>
            <StyledIconWrapper>
              <ThreeSixtyIcon style={{ position: "static", left: 0 }} />
            </StyledIconWrapper>
            <ColorsCarousel
              selectedColorIndex={selectedColorIndex}
              colorsData={filteredColors}
              handleColorChange={(index) => {
                dispatch(setSelectedColor(filteredColors[index]?.code))
              }}
              showExtraPrice
              pathname={pathname}
            />
          </>
        )}
      </StyledWrapper>
    </>
  )
}

export default memo(ColorSidebar)
